export enum Setting {
  RemoteAddress = 'remote_address',
  Secured = 'secured',
  Token = 'auth_token',
  Theme = 'theme',
  HideAntennaCheck = 'hide_antenna_check',
  WidgetsDisabled = 'widgets_disabled',
  WidgetsOrder = 'widgets_order',
}

export enum Theme {
  Light = 'light',
  Dark = 'dark',
}

